import React, { useState } from 'react';
import { CustomerComplaintForm } from '@/components/forms/CustomerComplaintForm';
import { complaintsAPI } from '@/services/api';
import { useNavigate } from 'react-router-dom';

export const ComplaintPage: React.FC = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [submitSuccess, setSubmitSuccess] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (data: any) => {
    setIsLoading(true);
    try {
      await complaintsAPI.create(data);
      setSubmitSuccess(true);
      
      // Show success message for 2 seconds then redirect
      setTimeout(() => {
        navigate('/');
      }, 2000);
    } catch (error: any) {
      console.error('Failed to submit complaint:', error);
      alert(error.response?.data?.message || 'Failed to submit complaint. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  if (submitSuccess) {
    return (
      <div className="flex items-center justify-center p-4 min-h-[60vh]">
        <div className="text-center">
          <div className="w-16 h-16 mx-auto mb-4 bg-green-100 rounded-full flex items-center justify-center">
            <svg className="w-8 h-8 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
            </svg>
          </div>
          <h2 className="text-2xl font-bold text-foreground mb-2">Complaint Submitted Successfully!</h2>
          <p className="text-muted-foreground">Thank you for your feedback. We will review your complaint and get back to you soon.</p>
          <p className="text-sm text-muted-foreground mt-2">Redirecting to home page...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="container mx-auto p-4 py-8">
      <CustomerComplaintForm onSubmit={handleSubmit} isLoading={isLoading} />
    </div>
  );
};